import type {ReactNode} from 'react';
import {useSearchableListIndexContext} from '../../SearchableList/useSearchableList';

import type {AutocompleteOption} from '../_types';

export const useAutocompleteNoteText = ({
  defaultNote,
}: {
  defaultNote: ReactNode | undefined;
}) => {
  const {activeIndex, disabledIndices, flattenedOptions} =
    useSearchableListIndexContext();

  let activeNote = defaultNote;
  if (activeIndex !== null && !disabledIndices?.includes(activeIndex)) {
    const activeOption = flattenedOptions[activeIndex] as AutocompleteOption;
    /**
     * The return from `useOptionListNavigation` is typed as `BaseOptionType`.
     */
    activeNote = activeOption?.note ?? defaultNote;
  }

  return activeNote;
};
